import { render } from "./FaceUnusedNumber.vue?vue&type=template&id=52fd48c3&scoped=true"
import script from "./FaceUnusedNumber.vue?vue&type=script&lang=js"
export * from "./FaceUnusedNumber.vue?vue&type=script&lang=js"

import "./FaceUnusedNumber.vue?vue&type=style&index=0&id=52fd48c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52fd48c3"

export default script